import * as Effects from 'redux-saga/effects'
import { callFetch } from '../../../actions/fetch'
import notificationErrorMessageSendend from '../../../actions/notification/errorSended'
import { ISendNotificationErrorMMessage } from '../../../actions/notification/sendError'
import { fireToastError } from '../../../actions/toasts/fireToast'
import i18n from '../../../i18n'
import sendErrorMessage from '../../../models/User/sendErrorMessage'
import { NotificationActions } from '../../../reducers/userAccount/actionNames'
import { ActionNames } from '../../../utils/FetchActionsName'
import fetchActionsName from '../../../utils/FetchActionsName/fetchActionsName'

function* sendError(action: ISendNotificationErrorMMessage) {
  try {
    const actionNames = fetchActionsName(ActionNames.SendNotificationError)
    const [{ service }] = yield Effects.all([
      Effects.take(actionNames.output),
      Effects.put(
        callFetch(actionNames.input, actionNames.output, sendErrorMessage),
      ),
    ])

    yield Effects.call(service, action.recipient, action.subject, action.body)

    yield Effects.put(notificationErrorMessageSendend(action.notificationId))
  } catch (e) {
    console.error(e)
    yield fireToastError(i18n.t('error_server_response_2'))
  }
}

export default function*() {
  yield Effects.takeEvery(NotificationActions.SendError, sendError)
}
